// Ratkaisut v4 (#1474): solutions.v4 — the `ratkaisutV4` namespace. Keep keys in sync across fi / en / sv.

export const solutionsV4Fi = {
  mine: 'Omat',
  all: 'Kaikki',
  koosteTab: 'Kooste',
  allCount: 'Kaikki, {{count}} ratkaisua',
  loading: 'Ladataan ratkaisuja…',
  error: 'Ratkaisuja ei voitu ladata',
  noPivots: 'Ongelmakartan vipupisteitä ei ole vielä haettu. Kun fasilitaattori on hakenut ne Ongelmakartassa, voitte tarttua niihin täällä.',
  types: { konsensus: 'Yhteiset näkemykset', kiistanalainen: 'Kiistanalaiset', villi_kortti: 'Villit kortit', sokea_piste: 'Sokeat pisteet' },
  type: { konsensus: 'Yhteinen näkemys', kiistanalainen: 'Kiistanalainen', villi_kortti: 'Villi kortti', sokea_piste: 'Sokea piste' },
  directions: {
    vahennetaan: 'Vähennetään', lisataan: 'Lisätään', tehdaan_nakyvaksi: 'Tehdään näkyväksi', siirretaan_vastuuta: 'Siirretään vastuuta',
    avataan: 'Avataan', puretaan: 'Puretaan', tiukennetaan: 'Tiukennetaan', kevennetaan: 'Kevennetään',
  },
  pick: {
    title: 'Mihin vipupisteeseen tartutte?',
    hint: 'Kuution ehdotuksia Ongelmakartasta. Napauttakaa vipupistettä nähdäksenne, mitä se on nyt, kuka sitä hallitsee ja kuka häviäisi, jos se liikkuu.',
    own: 'Teidän ratkaisunne',
    instrument: 'Instrumentti: {{name}}',
    owner: 'Omistaja: {{name}}',
    problems: 'Ongelmia: {{count}}',
    solutions: 'Ratkaisuja: {{count}}',
    noSolutions: 'Ei vielä ratkaisuja',
    openTitle: 'Avoimet kysymykset',
    openLead: 'Näitä mekanismeja moni juurisyy jakaa, mutta niille ei löytynyt instrumenttia. Niistä voi keskustella, mutta niihin ei voi vielä tarttua.',
  },
  brief: {
    close: 'Sulje',
    aiMark: 'Kuution ehdotus: tekoäly muotoili tämän huoneen juurisyistä ja niiden lähteistä',
    blindSpot: 'Kuution ehdotus tutkimuksesta ja verkosta: tämä voisi olla huoneen sokea piste',
    instrument: 'Instrumentti',
    direction: 'suunta: {{direction}}',
    stateNow: 'Nyt',
    owner: 'Kuka sitä hallitsee',
    ownerUnknown: 'Ei tiedossa',
    resisters: 'Kuka häviäisi',
    loses: 'menettäisi {{what}}',
    problems: 'Ongelmat, joihin se ulottuu',
    solutions: 'Huoneen ratkaisut tähän',
    noSolutions: 'Ei vielä yhtään. Teidän voi olla ensimmäinen.',
    take: 'Tartu tähän',
  },
  kaikki: {
    empty: 'Huoneessa ei ole vielä ratkaisuja. Omat-näkymässä ryhmä tarttuu vipupisteeseen.',
    earlier: 'Aiemmat vipupisteet',
    untouched: 'Vipupisteet, joihin kukaan ei ole vielä tarttunut',
  },
  compose: {
    title: 'Ratkaisun kirjoittaminen',
    kicker: 'Ratkaisu vipupisteeseen',
    intro: 'Kertokaa omin sanoin, mitä haluaisitte tehdä. Kuutio kysyy kerrallaan yhden asian, jota arvio tarvitsee, ja kirjoittaa luonnoksen teidän sanoistanne.',
    startPlaceholder: 'Mitä tekisitte tälle vipupisteelle?',
    replyPlaceholder: 'Vastatkaa tai tarkentakaa…',
    start: 'Aloita',
    send: 'Lähetä',
    thinking: 'Kuutio miettii…',
    suggestions: 'Ehdotuksia, joita voitte käyttää',
    takeSuggestion: 'Otetaan mukaan: {{s}}',
    pivotTitle: 'Vipupiste lyhyesti',
    instrument: 'Instrumentti',
    stateNow: 'Nyt',
    owner: 'Hallitsee',
    losers: 'Häviäisi',
    unknown: 'Ei tiedossa',
    yourProposal: 'Teidän ehdotuksenne',
    yourProposalEmpty: 'Tähän kertyy, mitä itse sanotte.',
    draft: 'Luonnos',
    draftHint: 'Kuutio kirjoittaa sen teidän sanoistanne. Voitte muokata sitä suoraan.',
    titlePlaceholder: 'Ratkaisun otsikko',
    bodyPlaceholder: 'Mitä tehdään, kuka tekee ja miten',
    missing: 'Mitä arvio vielä tarvitsee',
    missingNone: 'Arviolla on mitä se tarvitsee.',
    aiMark: 'Kuution arvio keskustelun pohjalta, ei vielä varsinainen arvio',
    error: 'Jokin meni pieleen. Yrittäkää uudelleen.',
    save: 'Tallenna ratkaisu',
    saving: 'Tallennetaan…',
    back: 'Takaisin vipupisteisiin',
    leaveDraft: 'Luonnos ja keskustelu katoavat, jos palaatte nyt. Palataanko silti?',
    leave: 'Palaa',
  },
  moves: {
    title: 'Mitä ratkaisu liikuttaa',
    empty: 'Näkyy, kun keskustelu on alkanut.',
    noneThisTurn: 'Kuutio ei nimennyt tällä kierroksella, mitä luonnos liikuttaa. Arvio tallennuksen jälkeen kertoo sen.',
    intended: 'Tarkoitettu',
    side_effect: 'Sivuvaikutus',
    asIntended: 'Vipupisteen suuntaan',
    against: 'Vipupisteen suuntaa vastaan',
  },
  sources: { fold: 'Lähteet ({{count}})', unavailable: 'Lähteitä ei saatu haettua tällä kertaa.' },
  scores: {
    label: 'Pisteet',
    feasibility: 'Toteutettavuus',
    ambition: 'Kunnianhimo',
    effectiveness: 'Vaikuttavuus',
    change: 'edellisessä versiossa {{from}}',
    assessing: 'Kuutio arvioi ratkaisua…',
    failed: 'Arviota ei saatu tehtyä. Seuraava tallennus arvioi sen uudelleen.',
    noScores: 'Kuutio arvioi, mitä ratkaisu liikuttaa, mutta pisteitä ei saatu.',
    notYet: 'Ei vielä arviota.',
  },
  assessment: {
    close: 'Sulje',
    aiMark: 'Kuution arvio: tekoäly luki ratkaisun vipupisteitä ja työpajan lähteitä vasten. Se on keskustelun pohja, ei päätös.',
    noMoves: 'Arvion mukaan ratkaisu ei liikuta yhtään vipupistettä.',
    noAdverse: 'Haitallista liikettä ei löytynyt: {{why}}',
    strength: { low: 'vähän', medium: 'jonkin verran', high: 'paljon' },
    basis: { research: 'tutkimuksen pohjalta', analogue: 'vastaavan kokeilun pohjalta', reasoned: 'Kuution päättelyä' },
    problems: 'Ongelmat, joihin se tarttuu',
    noProblems: 'Arvion mukaan ratkaisu ei tartu yhteenkään kartan ongelmaan.',
    reach: { solves: 'Ratkaisee:', touches: 'Helpottaa:' },
    pathway: 'Kuka toimii ja milloin',
    horizon: { '0-2v': '0–2 v', '2-5v': '2–5 v', '5-10v': '5–10 v' },
    now: 'voi alkaa nyt',
    precondition: 'Edellyttää: {{what}}',
    noWayIn: 'Mikään askel ei voi alkaa nyt: ratkaisulla ei ole vielä sisäänpääsyä.',
    blockers: 'Mikä estää',
    canRemove: 'Voisi poistaa: {{who}}',
    threats: 'Uhat',
    watchFor: 'Varhainen merkki: {{what}}',
    improve: 'Paranna ratkaisua',
  },
  improve: {
    kicker: 'Teidän ratkaisunne',
    read: 'Lue arvio',
    writeNew: 'Kirjoita uusi ratkaisu tähän vipupisteeseen',
    back: 'Takaisin vipupisteisiin',
  },
  refine: {
    intro: 'Mitä mieltä olette arviosta? Kertokaa, missä Kuutio on väärässä tai mitä se ei huomannut. Kuutio sanoo, muuttaako se sen arviota, ja ehdottaa korjattua ratkaisua.',
    placeholder: 'Mihin arviossa ette usko?',
    send: 'Lähetä',
    thinking: 'Kuutio miettii…',
    proposal: 'Kuution ehdotus: teidän ratkaisunne korjattuna',
    accept: 'Hyväksy muutos',
    accepted: 'Versio {{version}} hyväksytty. Kuutio arvioi sen uudelleen.',
  },
  kooste: {
    title: 'Ratkaisut yhdessä',
    aiMark: 'Kuution kooste: tekoäly luki ratkaisut ja niiden arviot yhdessä. Puutteet on laskettu suoraan arvioista.',
    notYet: 'Fasilitaattori ajaa koosteen, kun ratkaisuja on arvioitu. Alla näkyy jo nyt, mihin ratkaisut eivät vielä ulotu.',
    running: 'Kooste on tekeillä. Alla näkyy jo nyt, mihin ratkaisut eivät vielä ulotu.',
    stale: 'Ratkaisuja on lisätty tai muutettu koosteen jälkeen. Puutteet alla ovat ajan tasalla, teksti ei.',
    tensions: 'Missä ratkaisut vetävät toisiaan vastaan',
    untouched: 'Vipupisteet, joita mikään ratkaisu ei liikuta',
    allMoved: 'Jokaista vipupistettä liikuttaa jokin ratkaisu.',
    problemsLeft: 'Ongelmat, joihin mikään ratkaisu ei tartu',
    allTaken: 'Jokaiseen ongelmaan tarttuu jokin ratkaisu.',
    opposed: 'Vipupisteet, joita liikutetaan molempiin suuntiin',
    triedElsewhere: 'Kokeiltu muualla',
    outcome: { worked: 'Toimi', mixed: 'Vaihtelevin tuloksin', failed: 'Ei toiminut', unclear: 'Tulos epäselvä' },
    metrics: {
      title: 'Mittarit, joissa vaikutus näkyisi',
      lead: 'Laskettu arvioista: ratkaisu, joka liikuttaa vipupistettä, ulottuu niiden juurisyiden mittareihin, joita vipupiste kantaa. Tämä kertoo, mistä vaikutusta kannattaa seurata, ei sitä, kuinka paljon mittari muuttuisi.',
      via: 'Vipupisteen kautta: {{list}}',
      own: 'sen oma mittari',
      measured: 'mitattu: {{value}} {{period}}',
      measuredNoValue: 'mitattu',
      notMeasured: 'ei vielä mitattu',
      none: 'Arvioidut ratkaisut eivät vielä ulotu yhteenkään mittariin.',
      unreached: 'Mittarit, joihin mikään ratkaisu ei ulotu: {{list}}',
    },
  },
  wall: {
    title: 'Ratkaisut',
    lead: 'Huoneen ratkaisut vipupisteittäin: mitä kukin liikuttaa ja miten Kuutio sen arvioi.',
    empty: 'Ratkaisuja ei ole vielä kirjoitettu.',
    justImproved: 'Juuri parannettu',
    assessing: 'Arvioidaan…',
    next: 'Seuraavaksi: Tulevaisuustestaus',
  },
  focus: {
    hint: 'Juurisyyt, joita vipupiste kantaa, ja niiden esteet ja ongelmat. Napauta jatkaaksesi.',
  },
};

export const solutionsV4En = {
  mine: 'Mine',
  all: 'All',
  koosteTab: 'Overview',
  allCount: 'All, {{count}} solutions',
  loading: 'Loading the solutions…',
  error: 'The solutions could not be loaded',
  noPivots: 'The problem map’s leverage points have not been found yet. Once the facilitator has found them in Problem mapping, you can take them on here.',
  types: { konsensus: 'Shared views', kiistanalainen: 'Contested', villi_kortti: 'Wild cards', sokea_piste: 'Blind spots' },
  type: { konsensus: 'Shared view', kiistanalainen: 'Contested', villi_kortti: 'Wild card', sokea_piste: 'Blind spot' },
  directions: {
    vahennetaan: 'Reduce', lisataan: 'Increase', tehdaan_nakyvaksi: 'Make visible', siirretaan_vastuuta: 'Shift responsibility',
    avataan: 'Open up', puretaan: 'Dismantle', tiukennetaan: 'Tighten', kevennetaan: 'Ease',
  },
  pick: {
    title: 'Which leverage point will you take on?',
    hint: 'Kuutio’s proposals from the problem map. Tap a leverage point to see what it is now, who controls it and who would lose if it moves.',
    own: 'Your solutions',
    instrument: 'Instrument: {{name}}',
    owner: 'Owner: {{name}}',
    problems: 'Problems: {{count}}',
    solutions: 'Solutions: {{count}}',
    noSolutions: 'No solutions yet',
    openTitle: 'Open questions',
    openLead: 'Many root causes share these mechanisms, but no instrument was found for them. They can be discussed, but not yet taken on.',
  },
  brief: {
    close: 'Close',
    aiMark: 'Kuutio’s proposal: AI worded this from the room’s root causes and their sources',
    blindSpot: 'Kuutio’s proposal from the research and the web: this could be the room’s blind spot',
    instrument: 'Instrument',
    direction: 'direction: {{direction}}',
    stateNow: 'Now',
    owner: 'Who controls it',
    ownerUnknown: 'Not known',
    resisters: 'Who would lose',
    loses: 'would lose {{what}}',
    problems: 'The problems it reaches',
    solutions: 'The room’s solutions for it',
    noSolutions: 'None yet. Yours could be the first.',
    take: 'Take this on',
  },
  kaikki: {
    empty: 'The room has no solutions yet. In Mine, a group takes on a leverage point.',
    earlier: 'Earlier leverage points',
    untouched: 'Leverage points nobody has taken on yet',
  },
  compose: {
    title: 'Writing a solution',
    kicker: 'A solution for the leverage point',
    intro: 'Say in your own words what you would like to do. Kuutio asks one thing at a time that the assessment needs, and writes a draft from your words.',
    startPlaceholder: 'What would you do about this leverage point?',
    replyPlaceholder: 'Answer or add detail…',
    start: 'Start',
    send: 'Send',
    thinking: 'Kuutio is thinking…',
    suggestions: 'Suggestions you can use',
    takeSuggestion: 'Let’s include: {{s}}',
    pivotTitle: 'The leverage point in brief',
    instrument: 'Instrument',
    stateNow: 'Now',
    owner: 'Controlled by',
    losers: 'Would lose',
    unknown: 'Not known',
    yourProposal: 'Your proposal',
    yourProposalEmpty: 'What you say yourselves collects here.',
    draft: 'Draft',
    draftHint: 'Kuutio writes it from your words. You can edit it directly.',
    titlePlaceholder: 'The solution’s title',
    bodyPlaceholder: 'What is done, who does it and how',
    missing: 'What the assessment still needs',
    missingNone: 'The assessment has what it needs.',
    aiMark: 'Kuutio’s reading of the conversation, not yet the assessment',
    error: 'Something went wrong. Please try again.',
    save: 'Save the solution',
    saving: 'Saving…',
    back: 'Back to the leverage points',
    leaveDraft: 'The draft and the conversation are lost if you go back now. Go back anyway?',
    leave: 'Go back',
  },
  moves: {
    title: 'What the solution moves',
    empty: 'Shows once the conversation has started.',
    noneThisTurn: 'Kuutio did not name what the draft moves on this turn. The assessment after saving will.',
    intended: 'Intended',
    side_effect: 'Side effect',
    asIntended: 'In the leverage point’s direction',
    against: 'Against the leverage point’s direction',
  },
  sources: { fold: 'Sources ({{count}})', unavailable: 'The sources could not be fetched this time.' },
  scores: {
    label: 'Scores',
    feasibility: 'Feasibility',
    ambition: 'Ambition',
    effectiveness: 'Effectiveness',
    change: 'previous version {{from}}',
    assessing: 'Kuutio is assessing the solution…',
    failed: 'The assessment could not be made. The next save will assess it again.',
    noScores: 'Kuutio assessed what the solution moves, but the scores could not be made.',
    notYet: 'Not assessed yet.',
  },
  assessment: {
    close: 'Close',
    aiMark: 'Kuutio’s assessment: AI read the solution against the leverage points and the workshop’s sources. It is a basis for discussion, not a decision.',
    noMoves: 'By the assessment, the solution moves no leverage point.',
    noAdverse: 'No harmful move found: {{why}}',
    strength: { low: 'a little', medium: 'somewhat', high: 'a lot' },
    basis: { research: 'from research', analogue: 'from a comparable measure', reasoned: 'Kuutio’s reasoning' },
    problems: 'The problems it takes on',
    noProblems: 'By the assessment, the solution takes on none of the map’s problems.',
    reach: { solves: 'Solves:', touches: 'Eases:' },
    pathway: 'Who acts and when',
    horizon: { '0-2v': '0–2 y', '2-5v': '2–5 y', '5-10v': '5–10 y' },
    now: 'can start now',
    precondition: 'Needs: {{what}}',
    noWayIn: 'No step can start now: the solution has no way in yet.',
    blockers: 'What blocks it',
    canRemove: 'Could remove it: {{who}}',
    threats: 'Threats',
    watchFor: 'Early sign: {{what}}',
    improve: 'Improve the solution',
  },
  improve: {
    kicker: 'Your solution',
    read: 'Read the assessment',
    writeNew: 'Write a new solution for this leverage point',
    back: 'Back to the leverage points',
  },
  refine: {
    intro: 'What do you make of the assessment? Say where Kuutio is wrong or what it missed. Kuutio says whether that changes its reading, and proposes the solution with the gap closed.',
    placeholder: 'What in the assessment do you not believe?',
    send: 'Send',
    thinking: 'Kuutio is thinking…',
    proposal: 'Kuutio’s proposal: your solution with the gap closed',
    accept: 'Accept the change',
    accepted: 'Version {{version}} accepted. Kuutio assesses it again.',
  },
  kooste: {
    title: 'The solutions together',
    aiMark: 'Kuutio’s overview: AI read the solutions and their assessments together. The gaps are computed directly from the assessments.',
    notYet: 'The facilitator runs the overview once solutions have been assessed. Below you can already see what the solutions do not reach yet.',
    running: 'The overview is being made. Below you can already see what the solutions do not reach yet.',
    stale: 'Solutions have been added or changed since the overview. The gaps below are current, the text is not.',
    tensions: 'Where the solutions pull against each other',
    untouched: 'Leverage points no solution moves',
    allMoved: 'Some solution moves every leverage point.',
    problemsLeft: 'Problems no solution takes on',
    allTaken: 'Some solution takes on every problem.',
    opposed: 'Leverage points moved both ways',
    triedElsewhere: 'Tried elsewhere',
    outcome: { worked: 'Worked', mixed: 'Mixed results', failed: 'Did not work', unclear: 'Outcome unclear' },
    metrics: {
      title: 'Metrics where the effect would show',
      lead: 'Computed from the assessments: a solution that moves a leverage point reaches the metrics of the root causes that leverage point carries. It says where to follow the effect, not how much a metric would change.',
      via: 'Through the leverage point: {{list}}',
      own: 'its own metric',
      measured: 'measured: {{value}} {{period}}',
      measuredNoValue: 'measured',
      notMeasured: 'not measured yet',
      none: 'The assessed solutions do not reach any metric yet.',
      unreached: 'Metrics no solution reaches: {{list}}',
    },
  },
  wall: {
    title: 'Solutions',
    lead: 'The room’s solutions by leverage point: what each moves and how Kuutio assesses it.',
    empty: 'No solutions have been written yet.',
    justImproved: 'Just improved',
    assessing: 'Being assessed…',
    next: 'Next: Future testing',
  },
  focus: {
    hint: 'The root causes the leverage point carries, with their obstacles and problems. Tap to go on.',
  },
};

export const solutionsV4Sv = {
  mine: 'Egna',
  all: 'Alla',
  koosteTab: 'Sammandrag',
  allCount: 'Alla, {{count}} lösningar',
  loading: 'Lösningarna laddas…',
  error: 'Lösningarna kunde inte laddas',
  noPivots: 'Problemkartans hävstångspunkter har inte hämtats än. När facilitatorn har hämtat dem i Problemkartläggning kan ni ta er an dem här.',
  types: { konsensus: 'Gemensamma synsätt', kiistanalainen: 'Omstridda', villi_kortti: 'Jokrar', sokea_piste: 'Blinda fläckar' },
  type: { konsensus: 'Gemensam syn', kiistanalainen: 'Omstridd', villi_kortti: 'Joker', sokea_piste: 'Blind fläck' },
  directions: {
    vahennetaan: 'Minska', lisataan: 'Öka', tehdaan_nakyvaksi: 'Synliggöra', siirretaan_vastuuta: 'Flytta ansvar',
    avataan: 'Öppna', puretaan: 'Avveckla', tiukennetaan: 'Skärpa', kevennetaan: 'Lätta',
  },
  pick: {
    title: 'Vilken hävstångspunkt tar ni er an?',
    hint: 'Kuutios förslag från problemkartan. Tryck på en hävstångspunkt för att se hur den är nu, vem som styr den och vem som skulle förlora om den rör sig.',
    own: 'Era lösningar',
    instrument: 'Instrument: {{name}}',
    owner: 'Ägare: {{name}}',
    problems: 'Problem: {{count}}',
    solutions: 'Lösningar: {{count}}',
    noSolutions: 'Inga lösningar än',
    openTitle: 'Öppna frågor',
    openLead: 'Många grundorsaker delar dessa mekanismer, men inget instrument hittades för dem. De kan diskuteras men ännu inte tas itu med.',
  },
  brief: {
    close: 'Stäng',
    aiMark: 'Kuutios förslag: AI formulerade detta från rummets grundorsaker och deras källor',
    blindSpot: 'Kuutios förslag från forskningen och webben: detta kan vara rummets blinda fläck',
    instrument: 'Instrument',
    direction: 'riktning: {{direction}}',
    stateNow: 'Nu',
    owner: 'Vem som styr den',
    ownerUnknown: 'Okänt',
    resisters: 'Vem som skulle förlora',
    loses: 'skulle förlora {{what}}',
    problems: 'Problemen den når',
    solutions: 'Rummets lösningar för den',
    noSolutions: 'Inga än. Er kan bli den första.',
    take: 'Ta er an den här',
  },
  kaikki: {
    empty: 'Rummet har inga lösningar än. I Egna tar en grupp sig an en hävstångspunkt.',
    earlier: 'Tidigare hävstångspunkter',
    untouched: 'Hävstångspunkter som ingen har tagit sig an än',
  },
  compose: {
    title: 'Att skriva en lösning',
    kicker: 'En lösning för hävstångspunkten',
    intro: 'Säg med egna ord vad ni vill göra. Kuutio frågar en sak i taget som bedömningen behöver och skriver ett utkast av era ord.',
    startPlaceholder: 'Vad skulle ni göra med den här hävstångspunkten?',
    replyPlaceholder: 'Svara eller förtydliga…',
    start: 'Börja',
    send: 'Skicka',
    thinking: 'Kuutio tänker…',
    suggestions: 'Förslag ni kan använda',
    takeSuggestion: 'Vi tar med: {{s}}',
    pivotTitle: 'Hävstångspunkten i korthet',
    instrument: 'Instrument',
    stateNow: 'Nu',
    owner: 'Styrs av',
    losers: 'Skulle förlora',
    unknown: 'Okänt',
    yourProposal: 'Ert förslag',
    yourProposalEmpty: 'Det ni själva säger samlas här.',
    draft: 'Utkast',
    draftHint: 'Kuutio skriver det av era ord. Ni kan redigera det direkt.',
    titlePlaceholder: 'Lösningens rubrik',
    bodyPlaceholder: 'Vad görs, vem gör det och hur',
    missing: 'Vad bedömningen ännu behöver',
    missingNone: 'Bedömningen har det den behöver.',
    aiMark: 'Kuutios läsning av samtalet, ännu inte bedömningen',
    error: 'Något gick fel. Försök igen.',
    save: 'Spara lösningen',
    saving: 'Sparar…',
    back: 'Tillbaka till hävstångspunkterna',
    leaveDraft: 'Utkastet och samtalet försvinner om ni går tillbaka nu. Gå tillbaka ändå?',
    leave: 'Gå tillbaka',
  },
  moves: {
    title: 'Vad lösningen rör',
    empty: 'Syns när samtalet har börjat.',
    noneThisTurn: 'Kuutio nämnde inte vad utkastet rör i den här omgången. Bedömningen efter sparandet gör det.',
    intended: 'Avsett',
    side_effect: 'Bieffekt',
    asIntended: 'I hävstångspunktens riktning',
    against: 'Mot hävstångspunktens riktning',
  },
  sources: { fold: 'Källor ({{count}})', unavailable: 'Källorna kunde inte hämtas den här gången.' },
  scores: {
    label: 'Poäng',
    feasibility: 'Genomförbarhet',
    ambition: 'Ambition',
    effectiveness: 'Verkan',
    change: 'föregående version {{from}}',
    assessing: 'Kuutio bedömer lösningen…',
    failed: 'Bedömningen kunde inte göras. Nästa sparande bedömer den igen.',
    noScores: 'Kuutio bedömde vad lösningen rör, men poängen kunde inte tas fram.',
    notYet: 'Inte bedömd än.',
  },
  assessment: {
    close: 'Stäng',
    aiMark: 'Kuutios bedömning: AI läste lösningen mot hävstångspunkterna och workshopens källor. Den är ett underlag för samtal, inte ett beslut.',
    noMoves: 'Enligt bedömningen rör lösningen ingen hävstångspunkt.',
    noAdverse: 'Ingen skadlig rörelse hittades: {{why}}',
    strength: { low: 'lite', medium: 'en del', high: 'mycket' },
    basis: { research: 'utifrån forskning', analogue: 'utifrån en jämförbar åtgärd', reasoned: 'Kuutios resonemang' },
    problems: 'Problemen den tar itu med',
    noProblems: 'Enligt bedömningen tar lösningen inte itu med något av kartans problem.',
    reach: { solves: 'Löser:', touches: 'Lindrar:' },
    pathway: 'Vem agerar och när',
    horizon: { '0-2v': '0–2 år', '2-5v': '2–5 år', '5-10v': '5–10 år' },
    now: 'kan börja nu',
    precondition: 'Kräver: {{what}}',
    noWayIn: 'Inget steg kan börja nu: lösningen har ännu ingen väg in.',
    blockers: 'Vad som hindrar',
    canRemove: 'Kunde undanröja det: {{who}}',
    threats: 'Hot',
    watchFor: 'Tidigt tecken: {{what}}',
    improve: 'Förbättra lösningen',
  },
  improve: {
    kicker: 'Er lösning',
    read: 'Läs bedömningen',
    writeNew: 'Skriv en ny lösning för den här hävstångspunkten',
    back: 'Tillbaka till hävstångspunkterna',
  },
  refine: {
    intro: 'Vad tycker ni om bedömningen? Säg var Kuutio har fel eller vad den missade. Kuutio säger om det ändrar dess läsning och föreslår lösningen med luckan täppt.',
    placeholder: 'Vad i bedömningen tror ni inte på?',
    send: 'Skicka',
    thinking: 'Kuutio tänker…',
    proposal: 'Kuutios förslag: er lösning med luckan täppt',
    accept: 'Godkänn ändringen',
    accepted: 'Version {{version}} godkänd. Kuutio bedömer den igen.',
  },
  kooste: {
    title: 'Lösningarna tillsammans',
    aiMark: 'Kuutios sammandrag: AI läste lösningarna och deras bedömningar tillsammans. Luckorna är beräknade direkt ur bedömningarna.',
    notYet: 'Facilitatorn kör sammandraget när lösningar har bedömts. Nedan syns redan vad lösningarna inte når än.',
    running: 'Sammandraget görs. Nedan syns redan vad lösningarna inte når än.',
    stale: 'Lösningar har lagts till eller ändrats efter sammandraget. Luckorna nedan är aktuella, texten inte.',
    tensions: 'Var lösningarna drar mot varandra',
    untouched: 'Hävstångspunkter som ingen lösning rör',
    allMoved: 'Någon lösning rör varje hävstångspunkt.',
    problemsLeft: 'Problem som ingen lösning tar itu med',
    allTaken: 'Någon lösning tar itu med varje problem.',
    opposed: 'Hävstångspunkter som rörs åt båda hållen',
    triedElsewhere: 'Prövat på annat håll',
    outcome: { worked: 'Fungerade', mixed: 'Blandade resultat', failed: 'Fungerade inte', unclear: 'Oklart resultat' },
    metrics: {
      title: 'Mätare där effekten skulle synas',
      lead: 'Beräknat ur bedömningarna: en lösning som rör en hävstångspunkt når mätarna för de grundorsaker som hävstångspunkten bär. Det säger var effekten bör följas, inte hur mycket en mätare skulle ändras.',
      via: 'Genom hävstångspunkten: {{list}}',
      own: 'dess egen mätare',
      measured: 'mätt: {{value}} {{period}}',
      measuredNoValue: 'mätt',
      notMeasured: 'inte mätt ännu',
      none: 'De bedömda lösningarna når ännu ingen mätare.',
      unreached: 'Mätare som ingen lösning når: {{list}}',
    },
  },
  wall: {
    title: 'Lösningar',
    lead: 'Rummets lösningar per hävstångspunkt: vad var och en rör och hur Kuutio bedömer den.',
    empty: 'Inga lösningar har skrivits än.',
    justImproved: 'Just förbättrad',
    assessing: 'Bedöms…',
    next: 'Nästa: Framtidstestning',
  },
  focus: {
    hint: 'Grundorsakerna som hävstångspunkten bär, med deras hinder och problem. Tryck för att gå vidare.',
  },
};
